module.exports = __webpack_public_path__ + "img/layer1_00001.98285393.png";